import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(20px);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(-50%) translateX(20px);
  }
  to {
    opacity: 0;
    transform: translateY(-50%) translateX(10px);
  }
`;

export const FloatingBtn = styled.button`
  position: fixed;
  left: 0;
  top: 50%;
  transform-origin: left top;
  transform: translateY(-50%) rotate(-90deg);
  z-index: 1100;

  display: inline-flex;
  align-items: center;
  gap: 6px;

  height: 36px;
  padding: 0 12px;

  background: ${({ isOpen }) => (isOpen ? '#2a2a2a' : '#1f1f1f')};
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);
  transition: background .2s ease, box-shadow .2s ease, transform .05s ease;

  &:hover {
    background: #2a2a2a;
    box-shadow: 0 8px 22px rgba(0,0,0,0.3);
  }

  &:active {
    transform: translateY(-50%) rotate(-90deg) scale(0.98);
  }

  @media (max-width: 768px) {
    height: 34px;
    padding: 0 10px;
  }
`;

export const FlagIcon = styled.img`
  width: 16px;
  height: 12px;
  object-fit: cover;
  border-radius: 2px;
`;

export const Arrow = styled.span`
  font-size: 10px;
  margin-left: 2px;
  transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
  transition: transform .2s ease;
`;

export const MenuContainer = styled.div`
  position: fixed;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1099;

  display: flex;
  flex-direction: column;
  gap: 4px;

  background: #1f1f1f;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.25);

  animation: ${({ isClosing }) => (isClosing ? fadeOut : fadeIn)} 0.3s ease forwards;

  @media (max-width: 768px) {
    left: 15px;
  }
`;

export const MenuItem = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  padding: 8px 12px;
  background: ${({ isActive }) => (isActive ? 'rgba(255,255,255,0.15)' : 'transparent')};
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  transition: background .2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(255,255,255,0.3);
  }
`;